import { axios } from '@/utils/request'

/**
 * 查询扫码记录
 *
 * @author liwei
 * @date 2022-06-10 20:30:14
 */
export function buQrcodeScanPage (parameter) {
  return axios({
    url: '/buQrcodeScan/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 扫码记录列表
 *
 * @author liwei
 * @date 2022-06-10 20:30:14
 */
export function buQrcodeScanList (parameter) {
  return axios({
    url: '/buQrcodeScan/list',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加扫码记录
 *
 * @author liwei
 * @date 2022-06-10 20:30:14
 */
export function buQrcodeScanAdd (parameter) {
  return axios({
    url: '/buQrcodeScan/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑扫码记录
 *
 * @author liwei
 * @date 2022-06-10 20:30:14
 */
export function buQrcodeScanEdit (parameter) {
  return axios({
    url: '/buQrcodeScan/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除扫码记录
 *
 * @author liwei
 * @date 2022-06-10 20:30:14
 */
export function buQrcodeScanDelete (parameter) {
  return axios({
    url: '/buQrcodeScan/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出扫码记录
 *
 * @author liwei
 * @date 2022-06-10 20:30:14
 */
export function buQrcodeScanExport (parameter) {
  return axios({
    url: '/buQrcodeScan/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
